export default __webpack_public_path__ + "static/media/icon_chevron-up.cfc3ead2.svg";